import {cloneDeep} from "lodash-es";
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';

const NS = 'DateGreaterThan'; // jshint ignore:line

export default function DateGreaterThan($timeout) { // as dateGreaterThan
  "ngInject";

  return {
    require: 'ngModel',
    link,
    restrict: 'A'
  };

  function link(scope, element, attrs, ngModel) {

    var validate = function (viewValue) {

      var dateGreaterThanStr = attrs.dateGreaterThan.replace('"', '').replace('"', '');
      var dateGreaterThan = new Date(dateGreaterThanStr);
      var greaterThanAllowEqual = Boolean(attrs.greaterThanAllowEqual);
      var greaterThanDateOnly = Boolean(attrs.greaterThanDateOnly);

      if (!ngModel.$modelValue || !ngModel.$viewValue || !dateGreaterThan ||
        !(dateGreaterThan instanceof Date) || dateGreaterThan.toString() === 'Invalid Date'
      ) {
        // It's valid because we have nothing to compare against
        ngModel.$setValidity('date-greater-than', true);
        $timeout(function () {
          validate(ngModel.$viewValue);
        }, 1000);
      } else {
        var modelDate = (viewValue && typeof viewValue === 'string' && (viewValue.indexOf('-') !== -1)) ?
          new Date(viewValue) :
          cloneDeep(ngModel.$modelValue);

        if (ngModel.$viewValue && typeof ngModel.$viewValue === 'string' && ngModel.$viewValue.indexOf('T') !== -1) {
          var parts = ngModel.$viewValue.split('T');
          var dateParts = parts[0].split('-');
          var hourParts = parts[1].split(':');
          modelDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]), Number(hourParts[0]), Number(hourParts[1]));
        } else if (ngModel.$viewValue && typeof ngModel.$viewValue === 'string' && ngModel.$viewValue.indexOf(':') !== -1) {
          var timeStr = ngModel.$viewValue;
          modelDate.setHours(Number(timeStr.split(':')[0]));
          modelDate.setMinutes(Number(timeStr.split(':')[1]));
        }
        // It's valid if model is lower than the model we're comparing against
        var valid;

        if (greaterThanDateOnly) {
          const timezoneId = AdminService.getVenueTimezoneId();
          modelDate = DateUtilsService.getClearDate(modelDate, timezoneId);
          dateGreaterThan = DateUtilsService.getClearDate(dateGreaterThan, timezoneId);
        }
        if (greaterThanAllowEqual) {
          valid = (modelDate.getTime() >= dateGreaterThan.getTime()) ? true : false;
        } else {
          valid = (modelDate.getTime() > dateGreaterThan.getTime()) ? true : false;
        }

        ngModel.$setValidity('date-greater-than', valid);
      }
      return viewValue;
    };

    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    attrs.$observe('dateGreaterThan', function () {
      // Whenever the comparison model changes we'll re-validate
      validate(ngModel.$viewValue);
    });
  }
}
